module.exports = __webpack_public_path__ + "img/f6-2-6.78e7dd48.png";